import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

export const PropertyTax = () => {
  return (
    <>
      <TopBanner content={"Property Tax"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>Your Share for Local Development</h2>
          <p>
            Property Tax is a tax you pay to the local municipal body for owning
            a property whether it’s a house, apartment, commercial space, or
            land.
          </p>
          <p>
            The amount depends on the size, location, type, and usage of the
            property. This money is used by local authorities to maintain roads,
            water supply, sewage, and other civic amenities.
          </p>

          <h3>Key Points:</h3>
          <ul>
            <li>Paid annually to the municipal corporation</li>
            <li>
              Calculated based on property area, usage (residential/commercial),
              and location
            </li>
            <li>
              Exemptions may be available for senior citizens or agricultural
              land
            </li>
            <li>Delay in payment may attract penalties</li>
          </ul>

          <p>
            Paying property tax keeps your ownership clear and
            your city running.
          </p>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default PropertyTax;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
